// @owners { team: patients }
import { type BACKGROUND_COLORS_VALUES, COLORS } from '@alto/design-library-tokens';
import { getBrand } from '@alto/design-system';

/**
 * The Progyny flow paints its pages with the brand's pink surface. FuzeRx has no pink surface in its
 * palette — every page there sits on the same neutral surface (Surface/neutral/base, PH-4224) — so
 * the brand's own `GREY_LIGHTEST` token is used instead of a hardcoded hex, keeping the flow in step
 * with the rest of the brand's surfaces.
 *
 * Every Progyny surface reads from this one function rather than repeating the brand check: the page
 * body, the header and the native stack background have to agree, otherwise the mismatch shows up as
 * a coloured band at the top of the screen or behind a navigation transition. `brandTint` is the pink
 * the other brands keep — most pages use `PINK_LIGHTEST`, the calculating screen uses `PINK_LIGHT`.
 *
 * It is a function, not a constant, because `COLORS` is swapped at runtime when the brand is
 * resolved — reading it at module load would capture the wrong brand's palette.
 */
export const getProgynyPageBackgroundColor = (
  brandTint: BACKGROUND_COLORS_VALUES = COLORS.BACKGROUND_COLORS.PINK_LIGHTEST,
): BACKGROUND_COLORS_VALUES => (getBrand() === 'fuzerx' ? COLORS.BACKGROUND_COLORS.GREY_LIGHTEST : brandTint);
